const MIN_AFFORDANCE_DELAY_MS = 200;
const MAX_AFFORDANCE_DELAY_MS = 700;

function getRandomDelay(random: () => number): number {
  const randomValue = Math.min(Math.max(random(), 0), 1);
  const delayRange = MAX_AFFORDANCE_DELAY_MS - MIN_AFFORDANCE_DELAY_MS + 1;

  return Math.min(
    MAX_AFFORDANCE_DELAY_MS,
    MIN_AFFORDANCE_DELAY_MS + Math.floor(randomValue * delayRange)
  );
}

export function getComposerAffordanceDelays(
  random: () => number = Math.random
): { left: number; right: number } {
  const left = getRandomDelay(random);
  const proposedRight = getRandomDelay(random);
  const right =
    proposedRight !== left
      ? proposedRight
      : left === MAX_AFFORDANCE_DELAY_MS
        ? left - 1
        : left + 1;

  return { left, right };
}
